import { getFunctions, httpsCallable } from "firebase/functions";

import { firebaseApp } from "./firebase";

const functions = getFunctions(firebaseApp, "us-east1");
type ContactBridgeResult = { contactId: string; duplicate: boolean; status: "recorded" };
type ContactBridgeInput = { consent?: "service_updates" | "thank_you" | "marketing"; email?: string; eventKey: string; name: string; phone?: string; sourceRecordId?: string };

export async function submitPublicCentralRsvpContact(input: ContactBridgeInput & { eventId: string; funeralHomeId: string; slug: string }) {
  const callable = httpsCallable<typeof input, ContactBridgeResult>(functions, "submitPublicCentralRsvpContact");
  return (await callable(input)).data;
}

export async function submitPublicCentralQrCheckInContact(input: ContactBridgeInput & { caseId: string; funeralHomeId: string }) {
  const callable = httpsCallable<typeof input, ContactBridgeResult>(functions, "submitPublicCentralQrCheckInContact");
  return (await callable(input)).data;
}

export async function submitPublicCentralFamilyIntakeContact(input: ContactBridgeInput & { token: string }) {
  const callable = httpsCallable<typeof input, ContactBridgeResult>(functions, "submitPublicCentralFamilyIntakeContact");
  return (await callable(input)).data;
}
